var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef } from 'react';
import { useAxiosService } from './axiosService';
class FieldGroupItemsService {
    constructor(axios) {
        this.axios = axios;
    }
    getFieldGroupItemsForFieldGroup(fieldGroupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get(`field-groups/${fieldGroupId}/field-group-items`);
            return data;
        });
    }
    moveFieldGroupItemUp(fieldGroupItemId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post(`field-group-items/${fieldGroupItemId}/moveUp`);
        });
    }
    moveFieldGroupItemDown(fieldGroupItemId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post(`field-group-items/${fieldGroupItemId}/moveDown`);
        });
    }
}
export const useFieldGroupItemsService = () => {
    const axios = useAxiosService();
    const { current: service } = useRef(new FieldGroupItemsService(axios));
    return service;
};
